const $$splitComponentImporter = () => import('/home/runner/work/graph-it/graph-it/apps/graphit/src/routes/_unauthed/auth/login.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
interface LoginSearch {
  redirect?: string;
}
export const Route = createFileRoute('/_unauthed/auth/login')({
  validateSearch: (search: Record<string, unknown>): LoginSearch => ({
    redirect: typeof search.redirect === 'string' ? search.redirect : undefined
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});